// Edit each paragraph and its mobile summary together. HTML links/emphasis are supported.
export const robotics = {
  "id": "panel-3",
  "type": "story",
  "title": "Robotics",
  "blocks": [
    {
      "heading": "Overview",
      "desktop": "Working with the University of Edinburgh's maker space and a strong team of peers, we built a robot that plays pool on a half-scale table. The semester-long project combined several engineering disciplines. We divided the robot's systems into key modules: electrical, robotic, computer vision and camera (see Image 2), structural support, and a mobile web app for user input. In a typical use case, the web app shows a real-time view of the pool balls and prompts the user to take a shot. The robot, which we called Pool Pal, then attempts to replicate that shot. At the end of the project, our robot could successfully pot pool balls at an impressive accuracy (see Video 1). I was responsible for designing, testing, and assembling the robotic system, which consisted of two main components: the gantry and the striking mechanism.",
      "mobile": "At Edinburgh, our team built <b>Pool Pal</b>, a robot that plays pool from shots chosen in a web app. I designed, tested and assembled its gantry and striking mechanism."
    },
    {
      "heading": "Reflection",
      "desktop": "Our design was well-received by the judges: out of 16 teams, we won the <b>Best Technical Skills Project award</b> and placed <b>second overall</b> at a university-hosted competition. Teamwork was critical to our success. With members collaborating across multiple systems, clear and consistent communication was essential. One example was calibrating the gantry system's sensors, which helped manage the loss of timing belt tension over time. Solving this problem required close collaboration between the electrical lead and me, as we combined our efforts to tackle the issue effectively.",
      "mobile": "We won <b>Best Technical Skills Project</b> and placed <b>second out of 16 teams</b>. Collaborating across mechanical, electrical and software systems strengthened my teamwork and problem-solving."
    }
  ],
  "images": [
    {
      "src": "./info_images/poolpallRobot.jpeg",
      "alt": "Robotics Image 1",
      "caption": "Pool Pal in idle position"
    },
    {
      "src": "./info_images/cv_model.jpeg",
      "alt": "Robotics Image 2",
      "caption": "OpenCV Model utilised in tracking and determining cue ball position"
    },
    {
      "src": "./info_images/poolPalApp.png",
      "alt": "Robotics Image 3",
      "caption": "Pool Pal web application UI'"
    }
  ],
  "videos": [
    {
      "type": "youtube",
      "url": "https://youtube.com/shorts/DzKbvQ7KY5g?si=_X_gQl-VDSMWCPVM",
      "description": "Pool Pal in operation"
    }
  ]
};
